// DashboardContentMessage component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import AddButton from '../../common/add_button/add_button.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'

class DashboardContentMessage extends Component {
  static get propTypes () {
    return {
      icon: PropTypes.object,
      info: PropTypes.string,
      infoPrefix: PropTypes.string,
      showAdd: PropTypes.bool,
      onAdd: PropTypes.func,
      className: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      icon: '',
      info: null,
      infoPrefix: '',
      showAdd: false,
      onAdd: null,
      className: ''
    }
  }

  render () {
    const { showAdd } = this.props
    const classes = classnames(
      'dashboard-contentmessage',
      {},
      this.props.className
    )

    return (
      <div className={classes}>
        <div className='header'>
          <div className='icon'>
            {this.props.icon}
          </div>
        </div>
        {this._renderInfo()}
        {showAdd && (
          <div className='splitter'>
            <AddButton onClick={this._onClickAdd.bind(this)} />
          </div>
        )}
      </div>
    )
  }

  /* Event handlers */
  _onClickAdd (e) {
    e.preventDefault()

    if (this.props.onAdd) {
      this.props.onAdd(e)
    }
  }

  /* Private function */

  _renderInfo () {
    const { infoPrefix, info } = this.props
    let bShowInfoClick = false
    if (infoPrefix && info) {
      bShowInfoClick = true
    }

    return (
      <div className='info'>
        {bShowInfoClick ? (
          <p className='info'>
            {infoPrefix && <IntlMessage ident={infoPrefix} />}
            <i className='icon icon-contact-add normal' />
            <IntlMessage ident={info} />
          </p>
        ) : (
          <p className='info'>
            <IntlMessage ident={info} />
          </p>
        )}
      </div>
    )
  }
}

export default DashboardContentMessage
